import classNames from 'classnames'
import React from 'react'
import { TAG_FOOTER_SOCIAL_NETWORKS_LINKS } from '../../../store/analytics/analytics.actionTypes'
import TagActionLink from '../../genericComponents/TagActionLink'
import facebook from '../../genericComponents/assets/facebook.svg'
import rss from '../../genericComponents/assets/rss.svg'
import twitter from '../../genericComponents/assets/twitter.svg'
import SVGIcon from '../../svg/SVGIcon'
import s from './SocialNetworkButtons.less'

export default function SocialNetworkButtons(props) {
  return (
    <ul className={s.socialNetworkList}>
      <li>
        <FacebookButton />
      </li>
      <li>
        <TwitterButton />
      </li>
      <li>
        <BlogButton />
      </li>
    </ul>
  )
}

export function FacebookButton(props) {
  return (
    <TagActionLink
      className={classNames(s.button, s.facebook)}
      href="https://www.facebook.com/MappyOfficiel"
      nofollow={true}
      targetBlank={true}
      title="Mappy sur Facebook"
      type={TAG_FOOTER_SOCIAL_NETWORKS_LINKS}
      tagInfo={{ target: 'Facebook_Mappy' }}
    >
      <SVGIcon url={facebook} ssrWhite={true} />
    </TagActionLink>
  )
}

export function TwitterButton(props) {
  return (
    <TagActionLink
      className={classNames(s.button, s.twitter)}
      href="https://twitter.com/Mappy"
      nofollow={true}
      targetBlank={true}
      title="Mappy sur Twitter"
      type={TAG_FOOTER_SOCIAL_NETWORKS_LINKS}
      tagInfo={{ target: 'Twitter_Mappy' }}
    >
      <SVGIcon url={twitter} ssrWhite={true} />
    </TagActionLink>
  )
}

export function BlogButton(props) {
  return (
    <TagActionLink
      className={classNames(s.button, s.blog)}
      href="https://blog.mappy.com"
      title="Blog Mappy"
      disableNoreferrer={true}
      targetBlank={true}
      type={TAG_FOOTER_SOCIAL_NETWORKS_LINKS}
      tagInfo={{ target: 'Blog_Mappy' }}
    >
      <SVGIcon url={rss} ssrWhite={true} />
    </TagActionLink>
  )
}
